const courts = {
  courts: 'Суды',
  case: 'Дело',
  caseNumber: 'Номер',
  currentCases: 'Текущие',
  closedCases: 'Закрытые',
  casesState: 'Состояние дел',
  listOfCases: 'Список дел',
  listOfMembers: 'Список участников',
  plaintiff: 'Истец',
  plaintiffs: 'Истцы',
  respondent: 'Ответчик',
  respondents: 'Ответчики',
  defendants: 'Ответчики',
  stakeholders: 'Заинтересованные лица',
  thirdPerson: 'Третье лицо',
  thirdPersons: 'Третьи лица',
  sumOfCase: 'Сумма дела',
  otherPerson: 'Заинт. лицо',
  otherPersons: 'Заинт. лица',
  claimAmount: 'Сумма иска',
  showAllDocuments: 'Показать все документы',
  arbitrage: 'Арбитраж',
};

export default courts;
